/**
 * Self-Service Calculator
 *
 * Contact: dap@visana.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ContractDuration } from '../model/contractDuration';
// @ts-ignore
import { GenderOrPrenatal } from '../model/genderOrPrenatal';
// @ts-ignore
import { Problem } from '../model/problem';
// @ts-ignore
import { SupplementaryInsurances } from '../model/supplementaryInsurances';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class SupplementaryInsurancesService {

    protected basePath = '/api/public';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get available supplementary insurances
     * @param saleOfferBegin 
     * @param dateOfBirth 
     * @param genderOrPrenatal 
     * @param zipCode 
     * @param bfsNumber 
     * @param hasBasicInsurance 
     * @param hasAnyOtherPersonBeforeWithLegalProtection 
     * @param contractDuration 
     * @param frameworkContractNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSupplementaryInsurances(saleOfferBegin: string, dateOfBirth: string, genderOrPrenatal: GenderOrPrenatal, zipCode: string, bfsNumber: number, hasBasicInsurance: boolean, hasAnyOtherPersonBeforeWithLegalProtection: boolean, contractDuration: ContractDuration, frameworkContractNumber?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json', context?: HttpContext, transferCache?: boolean}): Observable<SupplementaryInsurances>;
    public getSupplementaryInsurances(saleOfferBegin: string, dateOfBirth: string, genderOrPrenatal: GenderOrPrenatal, zipCode: string, bfsNumber: number, hasBasicInsurance: boolean, hasAnyOtherPersonBeforeWithLegalProtection: boolean, contractDuration: ContractDuration, frameworkContractNumber?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SupplementaryInsurances>>;
    public getSupplementaryInsurances(saleOfferBegin: string, dateOfBirth: string, genderOrPrenatal: GenderOrPrenatal, zipCode: string, bfsNumber: number, hasBasicInsurance: boolean, hasAnyOtherPersonBeforeWithLegalProtection: boolean, contractDuration: ContractDuration, frameworkContractNumber?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SupplementaryInsurances>>;
    public getSupplementaryInsurances(saleOfferBegin: string, dateOfBirth: string, genderOrPrenatal: GenderOrPrenatal, zipCode: string, bfsNumber: number, hasBasicInsurance: boolean, hasAnyOtherPersonBeforeWithLegalProtection: boolean, contractDuration: ContractDuration, frameworkContractNumber?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/problem+json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (saleOfferBegin === null || saleOfferBegin === undefined) {
            throw new Error('Required parameter saleOfferBegin was null or undefined when calling getSupplementaryInsurances.');
        }
        if (dateOfBirth === null || dateOfBirth === undefined) {
            throw new Error('Required parameter dateOfBirth was null or undefined when calling getSupplementaryInsurances.');
        }
        if (genderOrPrenatal === null || genderOrPrenatal === undefined) {
            throw new Error('Required parameter genderOrPrenatal was null or undefined when calling getSupplementaryInsurances.');
        }
        if (zipCode === null || zipCode === undefined) {
            throw new Error('Required parameter zipCode was null or undefined when calling getSupplementaryInsurances.');
        }
        if (bfsNumber === null || bfsNumber === undefined) {
            throw new Error('Required parameter bfsNumber was null or undefined when calling getSupplementaryInsurances.');
        }
        if (hasBasicInsurance === null || hasBasicInsurance === undefined) {
            throw new Error('Required parameter hasBasicInsurance was null or undefined when calling getSupplementaryInsurances.');
        }
        if (hasAnyOtherPersonBeforeWithLegalProtection === null || hasAnyOtherPersonBeforeWithLegalProtection === undefined) {
            throw new Error('Required parameter hasAnyOtherPersonBeforeWithLegalProtection was null or undefined when calling getSupplementaryInsurances.');
        }
        if (contractDuration === null || contractDuration === undefined) {
            throw new Error('Required parameter contractDuration was null or undefined when calling getSupplementaryInsurances.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (saleOfferBegin !== undefined && saleOfferBegin !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>saleOfferBegin, 'sale_offer_begin');
        }
        if (dateOfBirth !== undefined && dateOfBirth !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>dateOfBirth, 'date_of_birth');
        }
        if (genderOrPrenatal !== undefined && genderOrPrenatal !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>genderOrPrenatal, 'gender_or_prenatal');
        }
        if (zipCode !== undefined && zipCode !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>zipCode, 'zip_code');
        }
        if (bfsNumber !== undefined && bfsNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>bfsNumber, 'bfs_number');
        }
        if (hasBasicInsurance !== undefined && hasBasicInsurance !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>hasBasicInsurance, 'has_basic_insurance');
        }
        if (hasAnyOtherPersonBeforeWithLegalProtection !== undefined && hasAnyOtherPersonBeforeWithLegalProtection !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>hasAnyOtherPersonBeforeWithLegalProtection, 'has_any_other_person_before_with_legal_protection');
        }
        if (contractDuration !== undefined && contractDuration !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>contractDuration, 'contract_duration');
        }
        if (frameworkContractNumber !== undefined && frameworkContractNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>frameworkContractNumber, 'framework_contract_number');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/problem+json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/supplementary-insurances`;
        return this.httpClient.request<SupplementaryInsurances>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
